import { Column } from '@shipt/design-system-layouts'
import { formatDate } from '@/features/shared/utils/date'
import { Headline } from '@shipt/design-system-typography'
import styled from 'styled-components'
import { theme } from '@/features/shared/constants/shiptTheme'

type Props = {
  date: string
}

export const BlogPostDate = ({ date }: Props) => {
  return (
    <Wrapper>
      <Headline size="md" as="p" surface="inverse">
        {formatDate(date, 'd')}
      </Headline>
      <Headline as="p" surface="inverse">
        {formatDate(date, 'MMM').toUpperCase()}
      </Headline>
    </Wrapper>
  )
}

const Wrapper = styled(Column)`
  width: 85px;
  height: 85px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: ${theme.color.content.action.secondary};
  color: ${theme.white};
`
